import { FreeShippingSchema } from '@xshop/shared';
import { fetchApi } from '../api/client';
import { useStoreRead } from '../elements/render/useStoreRead';
import { cartMoney } from './cartMoney';
import type { Commerce } from './ShopCommerce';
import { shopWords } from './shopWords';

// Sleek's "Spend $121.00 more to reach free shipping!" over the cart lines, with a bar filling towards it.
// The amount is the store's own: the lowest order total at which one of its delivery rates costs nothing,
// so the bar never promises what the checkout will not charge. A store with no free rate shows no bar.

// Reads the order total from which this store delivers free to Morocco, or null.
async function readThreshold(): Promise<number | null> {
  return FreeShippingSchema.parse(await fetchApi<unknown>('/shipping/free-threshold?country=MA')).threshold;
}

// Draws how far the cart is from free delivery, or that it has it; nothing for a store that never delivers free.
export const FreeShippingBar: React.FC<{ commerce: Commerce }> = ({ commerce }) => {
  const read = useStoreRead('free-shipping:MA', readThreshold);
  const threshold = read.data;
  const subtotal = commerce.quote?.subtotal;
  if (threshold === null || threshold === undefined || subtotal === undefined) return null;
  const left = Math.max(0, threshold - subtotal);
  const share = threshold === 0 ? 100 : Math.min(100, (subtotal / threshold) * 100);
  return (
    <div className="xe-cart-goal">
      <p aria-live="polite">
        {left > 0 ? <>{shopWords(commerce.language).spendMore[0]}<strong>{cartMoney(left, commerce.currency, commerce.direction)}</strong>{shopWords(commerce.language).spendMore[1]}</> : shopWords(commerce.language).shipsFree}
      </p>
      <span className="xe-cart-goal-track" aria-hidden="true"><span style={{ width: `${share}%` }} /></span>
    </div>
  );
};
